export const categories = {
  wholesale: {
    name: 'Wholesale',
    color: '#f07856',
    description: `The wholesale cost is the base price of buying power.

                It is the price that electricity suppliers pay when they purchase power from electricity generators.

                Wholesale prices vary a lot throughout the day and year. Power is cheap when renewables are plentiful, and expensive when demand is high.

                The wholesale price is still mostly set by the price of gas. This is why electricity bills exploded in 2022.`,
    timeSeries: {
      data: [179.61, 149.10, 166.69, 183.26, 213.27, 169.84, 219.91, 837.53, 584.29, 310.73, 319.60, 336.99],
      years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26', '26 FYTD']
    },
    subcategories: null
  },
  network: {
    name: 'Network Costs',
    color: '#faaaaf',
    description: 'Costs related to the transmission and distribution of electricity.',
    subcategories: {
        DUoS: {
          name: 'Distribution Costs',
          subtitle: "(DUoS)",
          description: `The distribution network is the local part of the power grid. It's the small wires and poles that bring electricity to your home.

          It costs a lot to build and maintain. Think fixing faults, cutting trees, attending to power cuts.

          Distribution costs are expected to increase, because upgrades are needed to service distributed generation,electric vehicles, heat pumps, and data centres.
          `,
          timeSeries: {
            data: [84.96, 91.02, 84.00, 81.80, 86.65, 88.19, 93.87, 135.14, 110.38, 137.57, 114.00, 117.88],
            years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26', '26 FYTD']
          }
        },
      TNUoS: {
        name: 'Transmission Costs',
        subtitle: "(TNUoS)",
        description: `The transmission network is for moving electricity long distances. It's the big pylons that teleport electricity around the country.

        For several decades, the UK hasn't built many new transmission lines. But we are about to start building a lot more, to connect new generation (mostly wind), and new load. Transmission costs are forecast to increase significantly.
        `,
        timeSeries: {
          data: [31.91, 38.02, 37.72, 37.71, 39.51, 37.42, 40.26, 42.30, 45.24, 40.11, 51.66, 83.60],
          years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26', '26 FYTD']
        }
      },
      BSUoS: {
        name: 'Balancing Costs',
        subtitle: "(BSUoS)",
        description: `Electricity supply and demand must be matched in time and space.

        To do this, the grid operator pays some generators to produce more power, and others to produce less. Balancing costs are the money spent to make these tweaks.

        Balancing costs used to be small, but are increasing. This is because (1) renewables are more volatile, and (2) we don't have sufficient grid capacity to transmit all the electricity that we generate.`,
        timeSeries: {
          data: [6.70, 6.98, 8.29, 7.99, 9.52, 12.03, 15.06, 23.41, 68.30, 33.51, 42.94, 46.89],
          years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26', '26 FYTD']
        }
      }
    }
  },
  renewables: {
    name: 'Generation Subsidies',
    color: '#B4F3F3',
    description: '',
    subcategories: {
      RO: {
        name: 'Renewables Obligation (RO)',
        description: `The Renewables Obligation was the UK's first renewables subsidy. It obliges energy suppliers to buy certificates from wind and solar farms.

        It started in 2002 and closed to new projects in 2017. We'll continue to pay for energy generated by these projects until 2037.

        It was stopped in 2017 because wind and solar had gotten quite a bit cheaper. It was replaced by the Contracts for Difference (CfD) programme.`,
        timeSeries: {
          data: [39.85, 48.57, 59.37, 73.10, 73.93, 74.40, 81.54, 86.24, 85.12, 98.53, 102.49, 25.36],
          years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26', '26 FYTD']
        }
      },
      CfD: {
          name: 'Contracts for Difference (CfD)',
          description: `Contracts for Difference are the currently UK's primary mechanism for procuring renewables. They guarantee a renewable generator a fixed price for their electricity.

          <img src="/cfd_svg.svg" alt="CfD mechanism diagram" style="width: 100%; margin: 2px 0;" />

          Usually, the market price is below the fixed price. But during the 2022 energy crisis, generators paid back excess £ to consumers.

          Over half of the contracts allocated have not yet been activated, so future CfD costs will increase substantially (unless wholesale prices rise, which would be bad).
          `,
          timeSeries: {
              data: [0.13, 2.54, 8.40, 14.08, 19.94, 30.57, 30.52, -22.19, -3.19, 34.05, 34.53, 33.06],
              years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26', '26 FYTD']
            }
        },
        FiT: {
          name: 'Feed-in Tariff (FiT)',
          description: `The Feed-in Tariff gave households with solar panels an extra payment per kWh of energy generated. This incentivised a lot of people to buy solar panels between 2010-2019.

          The scheme guaranteed high payments for 20-25 years, and proved more popular than expected. Rates were repeatedly cut to avoid costs climbing out of control.

          The FiT closed to new projects in 2019, but payments will continue to existing projects until the early 2040s.`,
          timeSeries: {
            data: [14.37, 16.46, 18.58, 19.25, 21.24, 17.87, 20.89, 23.19, 22.74, 24.23],
            years: ['FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26', '26 FYTD']
          }
        },
        SizewellCRAB: {
          name: 'Sizewell C RAB',
          description: `Sizewell C is a new nuclear power station being built in Suffolk. It uses the Regulated Asset Base (RAB) model, where consumers contribute to construction costs through their bills before the plant generates any electricity.

          The RAB model reduces financing costs by providing a guaranteed revenue stream during construction, but means consumers start paying years before the plant is operational.`,
          timeSeries: {
            data: [4.13, 14.78],
            years: ['FY 25-26', '26 FYTD']
          }
        },
      CM: {
        name: 'Capacity Market',
        description: `As demand increases and supply becomes more intermittent, the Capacity Market ensures that there is always enough power standing by to keep the lights on.

        The Capacity Market provides a long-term revenue stream to incentivise investment into reliable power stations, batteries, and demand-side flexibility.

        Securing this capacity is becoming more expensive. The majority of contracts for the next four years have already been allocated, and costs will more than double from 2025 to 2028.`,
        timeSeries: {
          data: [0.07, 0.27, 3.41, 11.40, 14.92, 18.27, 14.58, 10.48, 17.56, 21.37, 27.65, 48.18],
          years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26', '26 FYTD']
        }
      }
    }
  },
  misc: {
      name: 'Miscellaneous',
      color: '#E5CBFF',
      description: 'Other operational and regulatory costs.',
      subcategories: {
          SC: {
              name: 'Supplier Costs & Margin',
              description: `Energy suppliers incur operating costs to serve consumers: customer service, bad debt, metering costs, staffing, payment processing, and more.

                Since 2019, suppliers' profit margins have been capped at 1.9% or below. During the energy crisis, most suppliers operated at a loss.

                Note: the cost below is the upper limit for operating costs in the OFGEM price cap. Efficient suppliers will incur lower costs.`,
              timeSeries: {
                  data: [82.13, 82.70, 84.54, 86.87, 88.81, 89.64, 91.38, 76.73, 107.35, 109.55, 135.35, 143.68],
                  years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26', '26 FYTD']
              }
          },
          VAT: {
              name: 'VAT',
              description: 'VAT on electricity and gas bills was charged at 5% from 1994 until it was removed in 2026. \n\n While it applied, it scaled proportionally with the rest of the bill.',
              timeSeries: {
                data: [22.22, 21.92, 24.19, 26.89, 29.92, 28.93, 32.34, 62.54, 54.29, 43.28, 45.37],
                years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26']
              }
          },
          SMNCC: {
              name: 'Smart Meter Net Cost Change',
              description: `Energy suppliers are obgligated to roll out smart meters. They have to buy the meters, pay people to install them, and finance the data systems to collect readings.

              There is no upfront charge to domestic consumers for having a smart meter installed. Therefore, energy suppliers recover the cost from their entire customer base.`,
              timeSeries: {
                  data: [null, null, null, 6.94, 13.96, 16.73, 16.51, 15.61, 16.11, 17.63, 4.34, -2.52],
                  years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26', '26 FYTD']
              }
          },
          ECO: {
              name: 'Energy Company Obligation (ECO)',
              description: `ECO ended in April 2026.
              
              Prio to that, energy suppliers were obliged to pay for insulation and heating upgrades in poorer households.

              Suppliers had to find eligible homes and arrange for improvements like loft insulation, cavity wall filling, or new boilers. The costs were distributed amongst everyone's bills.`,
              timeSeries: {
                  data: [11.78, 11.86, 9.42, 10.32, 11.11, 14.03, 13.61, 16.40, 22.07, 26.95, 27.36],
                  years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26']
              }
          },
          WHD: {
              name: 'Warm Home Discount',
              description: `The Warm Home Discount provides a £150 reduction on winter electricity bills to poorer households and pensioners.

                It automatically appears as a one-off discount on eligible people's bills between October and March. The costs are distributed amongst everyone's bills.`,
              timeSeries: {
                  data: [6.56, 6.62, 6.70, 7.11, 7.24, 7.21, 7.05, 9.84, 10.30, 10.91, 16.10, 3.41],
                  years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26', '26 FYTD']
              }
          },
          NCC: {
              name: 'Network Charging Compensation',
              subtitle: "(NCC)",
              description: `The Network Charging Compensation scheme reduces levy costs on Energy Intensive Industries (EII), which spreads additional cost over businesses and households.

              The NCC began being charged in 2025.`,
              timeSeries: {
                  data: [null, null, null, null, null, null, null, null, null, null, 3.20, 3.74],
                  years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26', '26 FYTD']
              }
          },
          AAHEDC: {
              name: 'Assistance for Areas with High Electricity Distribution Costs',
              subtitle: "(AAHEDC)",
              description: `This scheme subsidises power lines in remote areas of North Scotland. With few customers and harsh weather, it's expensive to maintain the power grid in remote Highland areas.

              Everyone else pays a small amount on their bill to support this.

              <!--no-export-->If you don't pay it, a Highland Cow will be dispatched to follow you around, and your water supply will be switched to exclusively dispense Irn-Bru.`,
              timeSeries: {
                  data: [0.73, 0.78, 0.78, 0.83, 0.89, 1.03, 1.38, 1.40, 1.44, 1.45, 1.40, 1.42],
                  years: ['FY 15-16', 'FY 16-17', 'FY 17-18', 'FY 18-19', 'FY 19-20', 'FY 20-21', 'FY 21-22', 'FY 22-23', 'FY 23-24', 'FY 24-25', 'FY 25-26', '26 FYTD']
              }
          }
      }
  }
};